var map = {
	"./SalesforceLogo.png": 8314,
	"./awslogo.png": 2602,
	"./b.png": 1446,
	"./bauddhikgeeks-transparent.png": 3842,
	"./bauddhikgeeks.png": 6395,
	"./buld.jpg": 4281,
	"./crest-1.png": 8663,
	"./crest.png": 8325,
	"./cwoc.png": 5933,
	"./efi.png": 850,
	"./flutter.png": 8846,
	"./gdg.png": 7896,
	"./github.png": 647,
	"./googleAssistant.jpg": 1659,
	"./google_logo.png": 9389,
	"./gtu.png": 6058,
	"./hackathon1.svg": 7392,
	"./hackerrank-logo.png": 1360,
	"./hari-crop.png": 6629,
	"./harikrushn.jpg": 9573,
	"./iit.png": 7878,
	"./ino.png": 7192,
	"./ivbit.png": 9686,
	"./jntu-logo.jpeg": 4532,
	"./localguide.gif": 5590,
	"./localguide.png": 8585,
	"./mlh-logo.png": 8309,
	"./mlh-logo.svg": 5723,
	"./mlh.png": 5253,
	"./mongo.png": 948,
	"./monosoft.png": 7811,
	"./moz2.webp": 3132,
	"./mozilla.png": 1044,
	"./mscorp.png": 3922,
	"./nightowls.jpg": 515,
	"./postman.jpg": 2694,
	"./postman.png": 3826,
	"./skillenza.png": 6613,
	"./sm-logo.png": 9756,
	"./solultima.png": 8778,
	"./ssec.png": 6704,
	"./ssgandhy.png": 1727,
	"./sureify.png": 5751,
	"./sureify2.png": 5893,
	"./uta-logo.png": 6390,
	"./valora.jpg": 7737,
	"./wrighter.jpg": 8296,
	"./zemoso.png": 1319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;